var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58476 14.0666C7.92861 14.0666 9.93524 12.764 10.7636 10.9173C10.7738 10.8948 7.43773 11.7843 7.54411 11.4699C7.59161 11.3295 9.63661 10.5824 11.1265 9.71104C11.9829 9.21019 12.3772 8.14997 12.3772 8.14997C12.3772 8.14997 10.9345 8.85044 10.2051 9.02813C8.73539 9.38625 7.44161 9.34769 7.44161 9.31038C7.44161 9.22969 9.5899 8.8215 12.5758 7.00197C13.9802 6.14612 14.3617 4.67193 14.3617 4.67193C14.3617 4.67193 12.8176 5.59168 11.8842 5.89534C9.67055 6.61543 7.65048 6.83244 7.65048 6.735C7.65048 6.52637 9.42821 6.03753 11.313 5.12424C12.293 4.6494 13.1417 4.02902 14.1253 3.33911C15.7346 2.21033 16 0.199951 16 0.199951C16 0.199951 14.4127 1.22371 13.6382 1.56369C10.4419 2.96655 7.61967 3.70243 5.58476 3.86174C2.51301 4.10224 0 6.24547 0 9.02813C0 11.8108 2.50038 14.0666 5.58476 14.0666Z",
    fill: "#A6BBE8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlying);
export default __webpack_public_path__ + "static/media/flying.4ab543b4610684b947230a49f4abb372.svg";
export { ForwardRef as ReactComponent };